export enum RelevantExecutionRuleEnum {
    AUTO_ADD_EXECUTIONS = 1, // auto add executions within date range
    MANUALLY_ADD_EXECUTIONS = 2, // do not auto add executions
    AUTO_ADD_ALL_EXECUTIONS = 3, // auto add all executions
    AUTO_ADD_ALL_EXECUTIONS_WITH_AUTO_DEFAULT = 4, // auto add all and set newest published as default
}
